import { IApplicationState } from '../../types/redux';

export function selectChips(state: IApplicationState) {
  return state.filterSelectors;
}
